import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {submitBranchServiceStep, updateBranchServiceStep} from "../../services/branch_service_step/branch_service_step";
import {BranchServiceStepContext} from "../../context/branch_service_step_context";
import {getFieldBranches} from "../../services/branch/branch";
import SelectInput from "../system/select";

export function BranchServiceStepForm() {

  const {
    modalOpen,
    setModalOpen,
    branchServiceStep,
    setBranchServiceStep,
    setLastDataRefresh
  } = useContext(BranchServiceStepContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  const [branchId, setBranchId] = useState(branchServiceStep?.branch_id ?? null)

  useEffect(() => {
    setBranchServiceStep(branchServiceStep => ({
      ...branchServiceStep,
      branch_id: branchId,
    }))
  }, [branchId]);

  const save = async () => {

    const data = branchServiceStep
    data.status = branchServiceStep?.status ? "enable" : "disable"

    let result;

    if (!branchServiceStep?.id) {
      result = await submitBranchServiceStep(data);
    } else {
      result = await updateBranchServiceStep(data);
    }

    if (result.status === 200) {
      setBranchServiceStep({})
      setLastDataRefresh(Date.now());
      handleOpen();
    }
  };

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen} className="min-h-fit max-h-[650px]"
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <SelectInput
            label={Dict("raw_branch")}
            defaultValue={branchServiceStep?.branch_id}
            autoLoadService={getFieldBranches}
            autoLoadRender={({field_title, title}) => {
              return field_title + " - " + title
            }}
            onChange={setBranchId}
          />

          <div className="mb-4">
            <Input variant="standard"
                   value={branchServiceStep?.title ?? ""}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setBranchServiceStep(branchServiceStep => ({
                       ...branchServiceStep,
                       title: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={branchServiceStep?.description ?? ""}
                   label={Dict("description")}
                   placeholder={Dict("description")}
                   onChange={(e) => {
                     setBranchServiceStep(branchServiceStep => ({
                       ...branchServiceStep,
                       description: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={branchServiceStep?.step ?? ""}
                   label={Dict("service_step")}
                   placeholder={Dict("service_step")}
                   type="number"
                   min="1"
                   onChange={(e) => {
                     setBranchServiceStep(branchServiceStep => ({
                       ...branchServiceStep,
                       step: parseInt(e.target.value),
                     }))
                   }}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={branchServiceStep?.status !== "disable"}
              onChange={(e) => {
                setBranchServiceStep(branchServiceStep => ({
                  ...branchServiceStep,
                  status: e.target.checked,
                }))
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}